import { ButtonT10 } from "Components/Common/Button/index";
import { TypographyT55, TypographyT60 } from "Components/Common/Typography/index";
import { FlexWrapperT13 } from "Components/Common/Wrapper/FlexWrapper";
import { isDesmetSupplier } from "Utils/index";
import React, { Fragment } from "react";

const HeaderSection = (props) => {
  const { title, handleOnClickForCreateRequestBtn } = props;
  return (
    <Fragment>
      <FlexWrapperT13>
        <TypographyT60>{title}</TypographyT60>
        {isDesmetSupplier() && <ButtonT10 onClick={handleOnClickForCreateRequestBtn}>
          Create Request
        </ButtonT10>}
      </FlexWrapperT13>
    </Fragment>
  );
};

export default HeaderSection;
